// @mui
import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function SeaWaveFillIcon(props) {
  const theme = useTheme();
  const color = theme.palette.text.primary;
  return (
    <SvgIcon
      sx={{
        fill: "none",
      }}
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.2698 9.5504C19.7347 10.0453 19.0098 10.3586 18.2645 10.3292C17.2946 10.3292 16.5082 9.5428 16.5082 8.57281C16.5082 7.60281 17.2946 6.81647 18.2645 6.81647C18.8126 6.81647 19.0858 6.88998 19.5331 7.02111C18.9864 4.48551 15.8403 3.97434 14.0951 7.19248C13.1271 8.78061 12.1513 10.3946 10.4943 10.3292C9.52428 10.3292 8.73795 9.5428 8.73795 8.57281C8.73795 7.60281 9.52428 6.81647 10.4943 6.81647C11.0424 6.81647 11.3156 6.88998 11.7627 7.02111C11.2161 4.48551 8.05164 3.97434 6.30642 7.19248C4.79841 9.6665 3.6044 10.2775 2.98975 10.414"
        stroke={color || "#000000"}
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.98975 18.1891C3.52477 18.684 4.24969 18.9972 4.99493 18.9679C5.96492 18.9679 6.75127 18.1814 6.75127 17.2114C6.75127 16.2415 5.96492 15.4551 4.99493 15.4551C4.44684 15.4551 4.17365 15.5287 3.72643 15.6598C4.27308 13.1241 7.41918 12.613 9.16441 15.8312L9.17783 15.8531C10.1415 17.4342 11.1159 19.0329 12.7652 18.9679C13.7352 18.9679 14.5216 18.1814 14.5216 17.2114C14.5216 16.2415 13.7352 15.4551 12.7652 15.4551C12.2171 15.4551 11.9439 15.5287 11.4967 15.6598C12.0434 13.1241 15.2078 12.613 16.9531 15.8312C18.4611 18.3052 19.6551 18.9162 20.2698 19.0526"
        stroke={color || "#000000"}
        strokeWidth="1.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default SeaWaveFillIcon;
